<template>
  <div class="maintain-page">
    <Row>
      <i-Col span="3">
        <Select v-model="search1" :value="search1" filterable :placeholder="$t('Maintain.DeviceName')">
          <Option v-for="item in devices" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </i-Col>
      <i-Col span="3">
        <Select v-model="search2" :value="search2" filterable :placeholder="$t('Maintain.username')">
          <Option v-for="item in people" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </i-Col>
      <i-Col span="3" align="left" />
        <DatePicker class="info" type="datetime" format="yyyy-MM-dd HH:mm"  @on-change="entryTimeChange1" :value="selectTime1" :placeholder="$t('Maintain.please_enter_date1')"></DatePicker>
      </i-Col>
      <i-Col span="3" align="left" />
        <DatePicker class="info" type="datetime" format="yyyy-MM-dd HH:mm"  @on-change="entryTimeChange2" :value="selectTime2" :placeholder="$t('Maintain.please_enter_date2')"></DatePicker>
      </i-Col>
      <i-Col span="3" align="left" />
        <Button icon="ios-search" @click="handleSearch()"></Button>
        <Button icon="refresh" @click="handleReset()"></Button>
      </i-Col>
    </Row>
    <br>
    <Table class="maintain-table" highlight-row stripe border :columns="columns" :data="datas" :loading="loading"></Table>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Order',
  data () {
    return {
      columns: [
        { type: 'index', title: this.$t('Maintain.index'), width: 65 },
        { title: this.$t('Maintain.DeviceName'), key: 'DeviceName' },
        { title: this.$t('Maintain.username'), key: 'username' },
        { title: this.$t('Maintain.startTime'), key: 'startTime' },
        { title: this.$t('Maintain.endTime'), key: 'endTime' },
        { title: this.$t('Maintain.remark'), key: 'remark' },
        {
          title: this.$t('Maintain.action'),
          key: 'action',
          width: 125,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params.index)
                  }
                }
              }, this.$t('Maintain.edit'))
            ])
          }
        }
      ],
      search1: '',
      search2: '',
      selectTime1: '',
      selectTime2: '',
      datas: [],
      datasList: [],
      devices: [],
      people: [],
      loading: false
    }
  },
  computed: {
  },
  methods: {
    edit (index) {
      let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'MaintainEdit', params: { id } })
    },
    handleSearch () {
      this.loading = true
      this.datas = []
      let d1 = []
      let d2 = []
      let d3 = []
      if (this.search1 !== '') {
        for (let i = 0; i < this.datasList.length; i++) {
          if (this.datas[i].DeviceName.toLowerCase().indexOf(this.search1.toLowerCase()) !== -1) {
            d1.push(this.datasList[i])
          }
        }
      } else {
        d1 = this.datasList
      }
      if (this.search2 !== '') {
        for (let i = 0; i < d1.length; i++) {
          if (d1[i].username.toLowerCase().indexOf(this.search2.toLowerCase()) !== -1) {
            d2.push(d1[i])
          }
        }
      } else {
        d2 = d1
      }
      if (this.selectTime1 !== '') {
        let timestamp = new Date(this.selectTime1).getTime()
        for (let i = 0; i < d2.length; i++) {
          if (timestamp <= d2[i].timestamp) {
            d3.push(d2[i])
          }
        }
      } else {
        d3 = d2
      }
      if (this.selectTime2 !== '') {
        let timestamp = new Date(this.selectTime2).getTime()
        for (let i = 0; i < d3.length; i++) {
          if (timestamp >= d3[i].timestamp) {
            this.datas.push(d3[i])
          }
        }
      } else {
        this.datas = d3
      }
      this.loading = false
    },
    handleReset () {
      this.selectTime1 = ''
      this.selectTime2 = ''
      this.search1 = ''
      this.search2 = ''
      this.datas = this.datasList
    },
    entryTimeChange1 (v) {
      this.selectTime1 = v
    },
    entryTimeChange2 (v) {
      this.selectTime2 = v
    }
  },
  mounted () {
    Api.collector.list().then(res => {
      this.devices = res.collectors
    })
    Api.people.list().then(res => {
      this.people = res.accounts
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.maintain.list().then(res => {
      next(vm => {
        vm.datas = res.maintains
        vm.datasList = res.maintains
        for (let i = 0; i < vm.datas.length; i++) {
          let timestamp = new Date(vm.datas[i].startTime).getTime()
          vm.datas[i].timestamp = timestamp
          vm.datasList[i].timestamp = timestamp
        }
      })
    })
  }
}
</script>
<style>
.maintain-page {
  padding: 10px;
}

.maintain-table {
  margin-top: 20px;
}
</style>





// WEBPACK FOOTER //
// List.vue?189551f2